import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { WarningIcon } from 'foundations-assets';
import { Text } from 'foundations-components/components/Text';
import { Link } from 'foundations-components/transitional/components/Link';

// @ts-expect-error module not typed

// @ts-expect-error module not typed
import { isEmailCMF } from 'conversations-message-history/common-message-format/operators/cmfComparators';
import { getEmailClientName, getPublishFailedErrorPath } from './operators/getPublishFailedErrorString';
// @ts-expect-error module not typed
import { getMessageSendFailureSubscriptionType } from 'conversations-message-history/common-message-format/operators/commonMessageFormatGetters';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const FailedToPublishMessageText = ({
  message,
  onRepublish,
  allowRetry = true,
  connectedAccounts
}) => {
  const subscriptionType = getMessageSendFailureSubscriptionType(message);
  return /*#__PURE__*/_jsxs(Flex, {
    as: "span",
    gap: "100",
    alignItems: "start",
    children: [/*#__PURE__*/_jsx(Flex, {
      marginBlockStart: "50",
      children: /*#__PURE__*/_jsx(WarningIcon, {
        color: "fill-alert-default"
      })
    }), /*#__PURE__*/_jsxs(Text, {
      as: "small",
      use: "error",
      children: [getPublishFailedErrorPath(message, {
        clientType: getEmailClientName(message, connectedAccounts),
        subscriptionType,
        WhatsAppSizeLimits: 'https://developers.facebook.com/docs/whatsapp/cloud-api/reference/media#supported-media-types'
      }), !isEmailCMF(message) && allowRetry && /*#__PURE__*/_jsx(Link, {
        use: "danger",
        onClick: () => onRepublish(message),
        marginInlineStart: "100",
        children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: 'conversations-inbox-message-history.status.publishing.RETRY'
        })
      })]
    })]
  });
};
FailedToPublishMessageText.displayName = 'FailedToPublishMessageText';
export default FailedToPublishMessageText;